import PropTypes from "prop-types";

import { Bubble } from "react-chartjs-2";
import { comma } from "../../helpers/common.functions";

import { getCSSColorPalette } from "../../actions/cssColors";
import { divideByTenAndConstrain } from "./BenchmarkingMetrics.functions";

/// props validation | SQ(javascript:S6774)
GiaLRABubbleChart.propTypes = {
  skipHighlight: PropTypes.bool,
  data: PropTypes.array,
};
///
export default function GiaLRABubbleChart(props) {
  const { skipHighlight } = props;
  const { data } = props;

  const lragiaData = data.map((b) => ({
    project_name: b.project_name,
    lra: b.displayed_construction_cost_rate,
    gia: b.construction_cost / b.gia,
    lraValue: divideByTenAndConstrain(b.displayed_construction_cost_rate),
  }));
  const CSS_COLORS = getCSSColorPalette();

  const highlightColor = CSS_COLORS["--heritage"];
  const baseColor = CSS_COLORS["--fluidity1"];

  // Take all cost plans for this project
  let field = [];
  let gia = [];
  let lra = [];
  let lraValue = [];

  const options = {
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: "Cost per GIA",
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: "Cost Per LRA",
          },
        },
      ],
    },
    animation: {
      duration: 3000,
    },
    maintainAspectRatio: false,
    plugins: { datalabels: { display: true } },
    tooltips: {
      enabled: true,
      xPadding: 10,
      yPadding: 10,
      callbacks: {
        label: function (tooltipItem) {
          return field[tooltipItem.index] + " : " + comma(tooltipItem.yLabel);
        },
      },
    },

    legend: {
      display: false,
      position: "bottom",
      fullWidth: false,
      reverse: false,
    },
  };

  const getColor = (index) =>
    index === gia.length - 1 && !skipHighlight ? highlightColor : baseColor;

  lragiaData.forEach((b) => {
    field.push(b.project_name);
    gia.push(b.gia);
    lra.push(b.lra);
    lraValue.push(b.lraValue);
  });
  gia = gia.reverse();
  lra = lra.reverse();
  field = field.reverse();
  lraValue = lraValue.reverse();

  // The array of datasets for the graph
  const datasets = [];

  datasets.push({
    data: lra.map((bubble, index) => ({
      x: gia[index],
      y: bubble,
      r: lraValue[index],
    })),
    backgroundColor: getColor(gia.length - 1),
  });
  // Create the graph object
  let graph = {
    datasets: datasets,
  };

  return (
    <div className="metrics-chart">
      <Bubble data={graph} options={options} height={250} />
    </div>
  );
}
